import React from 'react';
import '../styles/ZwykDescription.css';
import ZwykUseCase from './ZwykUseCase';
import womanCamping from '../assets/woman-camping.avif';
import mountHikers from '../assets/mount-hikers.avif';
import summerMountainTrekking from '../assets/summer-mountain-trekking.jpg';

const ZwykDescription: React.FC = () => {
  return (
    <div className="zwyk-description">
      <div className="zwyk-description-container">
        <h1 className='zwyk-description-title '>
          Dla kogo jest ZWYK?
        </h1>
        <div className="zwyk-description-content">
          <p>
            <b>ZWYK</b> to słowo z góralskiej tradycji językowej. Dawniej „zwyk” oznaczał zwyczaj, obyczaj lub przyzwyczajenie – coś utrwalonego w lokalnej kulturze i przekazywanego kolejnym pokoleniom.
          </p>
          <p>
            Słowo ma również związek z pasterską historią naszych gór. W Beskidzie Żywieckim do dziś organizowany jest Zwyk Bacowski, przypominający dawne obrzędy związane z wypasem owiec.
          </p>
          <p>
            To właśnie lokalne korzenie, wspólnota i górska tradycja zainspirowały nas do nazwania aplikacji ZWYK.
          </p>
          <p>
            Dziś chcemy, żeby wspólne wyprawy, poznawanie nowych ludzi i odkrywanie gór stały się naszym własnym zwykiem.
          </p>
        </div>
      </div>
      <div className='use-cases-container'>
        <ZwykUseCase 
          imageUrl={womanCamping}
          imgHeader="Dla miłośników gór" 
          description="Dla wszystkich, którzy chcą podróżować wspólnie z innym!"
        />
        <ZwykUseCase 
          imageUrl={mountHikers}
          imgHeader="Dla organizacji turystycznych"
          description="Dla organizacji związanymi z turystyką górską, takich jak kluby/koła PTT, czy też kluby wysokogórskie."
        />  
        <ZwykUseCase 
          imageUrl={summerMountainTrekking}
          imgHeader="Dla przewodników"
          description="Dla przewodników, którzy chcą dotrzeć do nowych klientów."
        />
      </div>
    </div>
  );
};

export default ZwykDescription;